import { render, staticRenderFns } from "./OpenAuthorizationTab.vue?vue&type=template&id=529a2c10&scoped=true"
import script from "./OpenAuthorizationTab.vue?vue&type=script&lang=js"
export * from "./OpenAuthorizationTab.vue?vue&type=script&lang=js"
import style0 from "./OpenAuthorizationTab.vue?vue&type=style&index=0&id=529a2c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a2c10",
  null
  
)

export default component.exports